import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#B45309",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10 .75a9.25 9.25 0 1 1 0 18.5 9.25 9.25 0 0 1 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#B45309",
      stroke: "#B45309",
      "stroke-width": ".2",
      d: "M9.457 11.527c.01.165.056.305.152.404.098.101.232.145.388.145s.29-.044.388-.145c.096-.099.142-.239.152-.404l.312-5.578a.87.87 0 0 0-.208-.699.8.8 0 0 0-.644-.29.82.82 0 0 0-.66.292.94.94 0 0 0-.207.695zm-.158 3.342.002.003c.156.156.369.228.625.228h.142c.263 0 .479-.071.627-.23.145-.157.211-.369.211-.622v-.256c0-.26-.065-.475-.212-.623-.148-.159-.363-.23-.626-.23h-.142c-.256 0-.469.072-.625.228l.07.07-.07-.07c-.148.149-.213.363-.213.625v.255c0 .254.066.466.21.622Z"
    }, null, -1)
  ]))]))
}
export default { render: render }